<script lang="ts">
  import { getContext } from "svelte"
  import Dropdown from "$app/components/Dropdown.svelte"
  import { ArrowLeftToLine, House, ChevronDown, SquarePen } from "lucide-svelte"

  let { plan, current_user } = $props()

  const plan_role = current_user?.role

  let role = ""
  if (current_user && current_user.role) {
    role = current_user.role
  } else if (plan_role) {
    role = plan_role
  }

  import logo from "@images/logo/logo_white_small.png"

  let openDropdown = $state(false)
</script>

<nav class="bg-zinc-800 shadow" id="main-nav">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 main-nav">
    <div class="relative flex items-center justify-between h-16">
      <div class="flex-1 flex items-center justify-start">
        <div class="flex-shrink-0 flex items-center">
          <img src={logo} class="h-12 w-auto" alt="Lead With Purpose" />
        </div>
      </div>
      <div
        class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
      >
        {#if current_user}
          <div class="ml-4 flex items-center md:ml-6" id="user-menu">
            <a
              href="/plans/{plan.id}/community"
              class="p-1 border-2 border-transparent text-gray-200 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-indigo-600 flex items-center"
              aria-label="Community"
            >
              <House class="h-6 w-6" />
              <span class="ml-2 text-sm">Community</span>
            </a>
            <div class="ml-3 relative">
              <Dropdown bind:open={openDropdown}>
                {#snippet button()}
                  <span
                    data-name="nav-button"
                    class="focus:outline-none max-w-xs rounded-full flex items-center text-sm lg:p-2 lg:rounded-md"
                  >
                    <img
                      src={current_user.avatar_thumb_url}
                      class="h-8 w-8 rounded-full current-user-avatar"
                      alt={current_user.name}
                    />
                    <span
                      class="hidden ml-3 text-white text-sm font-medium lg:block"
                    >
                      <span class="sr-only">Open user menu for</span>
                      <span>{current_user.display_name}</span>
                    </span>
                    <ChevronDown
                      class="hidden flex-shrink-0 ml-1 h-5 w-5 text-gray-400 lg:block"
                    />
                  </span>
                {/snippet}
                <div>
                  <div
                    class="origin-top-right absolute right-0 mt-2 w-72 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 z-50"
                  >
                    <a
                      href={`/users/${current_user.id}/edit`}
                      class="group flex items-center px-4 py-3 text-sm text-gray-700 border-b border-gray-300 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      <SquarePen
                        class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500"
                      />
                      Account Settings
                    </a>
                    <a
                      href="/users/sign_out"
                      class="group flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                      role="menuitem"
                    >
                      <ArrowLeftToLine
                        class="h-5 w-5 mr-3 text-gray-400 group-hover:text-gray-500"
                      />
                      Log Out
                    </a>
                  </div>
                </div>
              </Dropdown>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</nav>
